// calculte if a data object is within the bounds given by gMaps .getBounds() method.
const isWithinBounds = (obj, bounds) => {
    //console.log("bounds : " , bounds );
    //console.log("obj : ", obj.toJS() );

  const latitude = obj.getIn(['geolocation', 'latitude']);
  const longitude = obj.getIn(['geolocation', 'longitude']);
  // const northEast = bounds._northEast;
  // const southWest = bounds._southWest;

  const getLongLat = (key, value) => { return Object.values(bounds[Object.keys(bounds)[key]])[value] };

  const N = getLongLat(0,1);
  const S = getLongLat(0,0);
  const E = getLongLat(1,1);
  const W = getLongLat(1,0);

 // console.log("latitude : " , latitude , " longitude : " , longitude );
 // const isLatInRange = latitude >= southWest.lat && latitude <= northEast.lat;
 //   if (northEast.lng < southWest.lng) {
 //     return (isLatInRange && longitude >= southWest.lng) || longitude <= northEast.lng;
 //   }
 // return isLatInRange && longitude >= southWest.lng && longitude <= northEast.lng;

  if( typeof latitude !== 'number' || typeof longitude !== 'number' ) {
// console.log("wrong lat, lng : " , obj);
	  return false; }

  const isLatInRange = latitude >= S && latitude <= N;
// console.log("isLatInRange : " , isLatInRange );

  if (E < W) {
// console.log(" E < W");
    return (isLatInRange && longitude >= W) || longitude <= E;
  }
// console.log("outcome : " ,  isLatInRange && longitude >= W && longitude <= E );
  return isLatInRange && longitude >= W && longitude <= E;
};

export default isWithinBounds;



// WEBPACK FOOTER //
// ./src/js/helpers/isWithinBounds.js